//Styles
import housingStyle from "../../styles/housing/HousingComponent.module.css"
//PrimeReact
import { Dialog } from "primereact/dialog"

//Housing pages
import Housing from "../../pages/Housing/Index"
import { useContext, useEffect, useState } from "react"

// Context
import { UserContext } from "../../context/userContext"

export default function HousingComponent() {
  const userCtx = useContext(UserContext)

  const [show, setShow] = useState(false)

  useEffect(() => {
    if (userCtx.housing.context.showHousing) {
      setShow(true)
      userCtx.housing.setHousing({
        ...userCtx.housing.context,
        showHousing: false,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userCtx.housing.context])

  return (
    <>
      <div
        className={housingStyle.topDropdownOptionDiv}
        onClick={() => {
          setShow(true)
        }}
      >
        <span className="material-icons">house</span>
        <label>Housing</label>
      </div>
      <Dialog
        header={"Housing"}
        visible={show}
        onHide={() => {
          setShow(false)
        }}
        style={{ minWidth: "1340px", width: "70vw", height: "1000px" }}
      >
        <Housing />
      </Dialog>
    </>
  )
}
